import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class InteiroTeorService extends ApiConfig {
  constructor(private http: HttpClient) {
    super();
  }

  ListarPorProjeto(projetoIds: string): Promise<any> {
    const url = `https://api.legislapp.com.br/InteiroTeor/ListarPorProjeto?${projetoIds}`;

    return new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        (data) => resolve(data),
        (error) => reject(error)
      );
    });
  }

  listarPorTag(tags: string): Promise<any> {
    const url = `https://api.legislapp.com.br/InteiroTeor/ListarPorTag?${tags}`;

    return new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        (data) => resolve(data),
        (error) => reject(error)
      );
    });
  }
}
